import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconBundleBlueprint } from '@backstage/plugin-app-react';
import {
  AzureIcon,
  DatadogIcon,
  GitLabIcon,
  MondayIcon,
  SignozIcon,
  SonarQubeIcon,
} from './toolkitIcons';

const toolkitIcons = IconBundleBlueprint.make({
  name: 'toolkit-icons',
  params: {
    icons: {
      gitlab: GitLabIcon,
      azure: AzureIcon,
      datadog: DatadogIcon,
      signoz: SignozIcon,
      monday: MondayIcon,
      sonarqube: SonarQubeIcon,
    },
  },
});

export const iconsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [toolkitIcons],
});
